module.exports = __webpack_public_path__ + "img/loggingin-image2.84457b07.png";